import { COMPANY_PERMISSION } from '@/core/entities/interfaces/permissions';
import ExportBeneficiariesButton
  from '@/modules/beneficiary/components/exportBeneficiariesButton/exportBeneficiariesButton';
import ExportBeneficiariesModal
  from '@/modules/beneficiary/components/exportBeneficiariesModal/exportBeneficiariesModal';
import {
  BeneficiarySearchParams,
  EXPORT_BENEFICIARIES_TYPE,
  ExportBeneficiarySearchParams,
} from '@/modules/beneficiary/entities/interfaces';
import {
  BeneficiariesTable,
  BeneficiariesTableColumns, BeneficiariesTableFilters,
} from '@/modules/beneficiary/views/beneficiariesTable/beneficiariesTable';
import Counter from '@/modules/beneficiary/views/counter/counter';
import { useBillingModel } from '@/modules/billing/hooks/useBillingModel';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import { LIST_INITIAL_PAGE, LIST_INITIAL_PAGE_SIZE } from '@/shared/entities/constants/list';
import { useQueryStringState } from '@/shared/hooks/useQueryStringState';
import { analytics } from '@/shared/telemetry/telemetry';
import { omit } from 'lodash';
import React, { useMemo, useState } from 'react';
import { Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface BeneficiaryQueryParams extends BeneficiarySearchParams {
  showMoreFilters?: boolean;
}

const List: React.FC = () => {
  const { checkUserHasPermission, user } = useCurrentUser();
  const { isCompanyFeeForService } = useBillingModel();
  const [showExportBeneficiaries, setShowExportBeneficiaries] = useState<boolean>(false);

  const [filters, setFilters] = useQueryStringState<BeneficiaryQueryParams>({
    page: LIST_INITIAL_PAGE,
    pageSize: LIST_INITIAL_PAGE_SIZE,
    status: 'ACTIVE',
    sort: 'life.name',
  });

  const [paramsToExport, setParamsToExport] = useState<ExportBeneficiarySearchParams>({
    exportType: EXPORT_BENEFICIARIES_TYPE.BASIC,
    status: 'ACTIVE',
    sort: 'life.name',
  })

  const canExportBeneficiary = useMemo(
    () => checkUserHasPermission(COMPANY_PERMISSION.BENEFICIARY_EXPORT),
    [checkUserHasPermission],
  );

  const handleExportBeneficiaries = (exportType: EXPORT_BENEFICIARIES_TYPE) => {
    analytics.track('[START] - Exportação de beneficiários');
    setParamsToExport({ ...omit(filters, ['page', 'pageSize']), exportType })
    setShowExportBeneficiaries(true);
  };

  return (
    <>
      <Grid gap={8}>
        <Text color='colorDefault' title size='medium' value='Lista de beneficiários' />
        {canExportBeneficiary && (
          <ExportBeneficiariesButton
            handleExportBeneficiaries={handleExportBeneficiaries}
            userType={user.type}
          />
        )}
      </Grid>

      <ExportBeneficiariesModal
        isOpen={showExportBeneficiaries}
        handleClose={setShowExportBeneficiaries}
        filters={paramsToExport}
      />

      <Counter filters={filters} />

      <BeneficiariesTable
        filters={filters}
        setFilters={setFilters}

        visibleColumns={isCompanyFeeForService ? [
          BeneficiariesTableColumns.NAME,
          BeneficiariesTableColumns.CPF,
          BeneficiariesTableColumns.HEALTH_CARD,
          BeneficiariesTableColumns.BENEFIT,
          BeneficiariesTableColumns.STATUS,
        ] : [
          BeneficiariesTableColumns.NAME,
          BeneficiariesTableColumns.CPF,
          BeneficiariesTableColumns.BENEFIT,
          BeneficiariesTableColumns.STATUS,
        ]}

        visibleFilters={isCompanyFeeForService ? [
          BeneficiariesTableFilters.NAME,
          BeneficiariesTableFilters.CPF,
          BeneficiariesTableFilters.STATUS,
          BeneficiariesTableFilters.TYPE,
          BeneficiariesTableFilters.HEALTH_CARD,
          BeneficiariesTableFilters.BENEFIT
        ] : [
          BeneficiariesTableFilters.NAME,
          BeneficiariesTableFilters.CPF,
          BeneficiariesTableFilters.STATUS,
          BeneficiariesTableFilters.TYPE,
          BeneficiariesTableFilters.BENEFIT
        ]}
      />
    </>
  );
};

export default List;
